module.exports = __webpack_public_path__ + "img/1622832_documents_email_envelope_feed_letter_icon.c81efddc.svg";